import * as Type from './actionsTypes';

const loadPedidos = filtro => ({ type: Type.FETCH_PEDIDOS, filtro });

const deletePedido = (id, callback) => ({ type: Type.DELETE_PEDIDO, id, callback });

const savePedido = (data, callback) => ({ type: Type.SAVE_PEDIDO, data, callback });

const updatePedido = (data, callback) => ({ type: Type.UPDATE_PEDIDO, data, callback });

const findPedidoById = id => ({ type: Type.PEDIDO_FIND_BY_ID, id });

const exportPedido = (filter, callbackAfterSave) => ({ type: Type.PEDIDO_EXPORT, filter, callbackAfterSave });

const loadPedidoFornecedorOptions = () => ({ type: Type.FETCH_PEDIDO_FORNECEDOR_OPTIONS });

export {
  loadPedidos,
  deletePedido,
  savePedido,
  updatePedido,
  findPedidoById,
  exportPedido,
  loadPedidoFornecedorOptions,
}
